export default "__VITE_ASSET__ByndQFHS__"